var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    transform: "translate(-670.000000, -3308.000000)",
    fill: "#1330E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(280.000000, 3158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(208.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(160.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(22.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.329474622,8.64069457 L4.48285841,8.64069457 L4.48285841,22 L0.329474622,22 L0.329474622,8.64069457 Z M2.40627783,2 C3.73374889,2 4.81255565,3.07880677 4.81255565,4.40850401 C4.81255565,5.73686554 3.73374889,6.81567231 2.40627783,6.81567231 C1.07569012,6.81567231 0,5.73686554 0,4.40850401 C0,3.07880677 1.07569012,2 2.40627783,2 M7.08704363,8.64069457 L11.0696794,8.64069457 L11.0696794,10.4674978 L11.126447,10.4674978 C11.6807658,9.41674087 13.0356189,8.30988424 15.0549866,8.30988424 C19.2595726,8.30988424 20.0356189,11.0759127 20.0356189,14.6729742 L20.0356189,22 L15.8853517,22 L15.8853517,15.5033393 C15.8853517,13.9536955 15.858415,11.9610419 13.7277382,11.9610419 C11.567008,11.9610419 11.2373108,13.6500445 11.2373108,15.3920303 L11.2373108,22 L7.08704363,22 L7.08704363,8.64069457 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.47835d6690539a47123e629f37d804cf.svg";
export { ForwardRef as ReactComponent };